import type { Editor } from '@tiptap/react';

import { setEditorAgentActive } from '@/hooks/llm/editor-suggestion-config';
import { getCachedEditor } from '@/hooks/use-block-editor/editor-cache';
import { isEditorAlive } from '@/utils/editor-utils';
import { endStreamingSession } from './streaming/streaming-preview';

export function getRequestEditor(requestId: string, editor?: Editor | null): Editor | null {
  if (isEditorAlive(editor)) return editor;

  const cachedEditor = getCachedEditor(requestId)?.editor;
  return isEditorAlive(cachedEditor) ? cachedEditor : null;
}

export function endEditorStreamingPreview(requestId: string, editor?: Editor | null): void {
  const activeEditor = getRequestEditor(requestId, editor);
  endStreamingSession(requestId);
  setEditorAgentActive(activeEditor, false);
}
